module.exports = __webpack_public_path__ + "img/annual-badge-pitch.51774b69.svg";